
<div class="flow-popover" :open="open" tabindex="0" @keydown.esc="handleEscapeClick" @click.stop>
	<div
		:open="open"
		:transparent="!overlay"
		class="flow-popover-overlay"
		@click.stop="handleOverlayClick($event)"
	/>
	<!-- @slot Used to display triggers element on which popover will be displayed -->
	<slot />
	<div v-show="open" ref="popOver" class="flow-popover-content">
		<!-- @slot Used to have Popover content-->
		<slot v-if="open" name="content" />
	</div>
</div>
